<div [ngClass]="{ 'half-screen': selected }" class="main-container">
    <app-list-header
        [title]="title"
        [closable]="!!choiceEvent.topic"
        [searchPlaceholder]="'branches.search' | translate"
        [searchTerm]="searchTerm | async"
        (searchTermChange)=" searchTerm.next($event);searchBranches()"
        (clearSearch)="clearBranchFilter()"
        (addNewItem)="createNewBranch()"
        >
    </app-list-header>

    <div class="table-container">
        <table class="table">
            <thead>
                <tr>
                    <th>{{ 'branchDetails.abbreviationLabel' | translate }}</th>
                    <th>{{ 'branchDetails.nameLabel' | translate }}</th>
                </tr>
            </thead>
            <tbody>
                <tr
                    *ngFor="let branch of filteredBranch | async"
                    (click)="select(branch)"
                    [class.selected]="branch === selected"
                    >
                    <td><span class="abbr-badge" *ngIf="branch.abbreviation">{{ branch.abbreviation }}</span></td>
                    <td class="name-cell">{{ branch.name }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
